import api from './api';
import { Dayjs } from 'dayjs';

// Interfaces based on the backend DTOs

export interface AssignedEmployee {
  maChamCong: string;
  tenNV: string;
  isKem: boolean;
}

export interface VitriTruc {
  vitriTrucId: number;
  tenViTri: string;
  moTa: string;
  thuTuHienThi: number;
}

export interface DutyScheduleDateColumn {
  date: string; // ISO string
  isApproved: boolean;
  lichtrucId: number | null;
}

export interface DutyScheduleData {
  positions: VitriTruc[];
  dates: DutyScheduleDateColumn[];
  assignments: { [key: string]: AssignedEmployee[] }; // Key: "vitriTrucId_yyyy-MM-dd"
}

export interface SaveDutyScheduleCell {
    vitriTrucId: number;
    employees: AssignedEmployee[];
}

export interface SaveDutyScheduleRequest {
    date: string; // ISO string
    assignments: SaveDutyScheduleCell[];
}

export interface Employee {
    macc: string;
    tennv: string;
    tenkk: string;
    viettat?: string;
}


const getDutySchedule = (fromDate: Dayjs, toDate: Dayjs): Promise<DutyScheduleData> => {
  return api.get('/dutyschedule', {
    params: {
      fromDate: fromDate.format('YYYY-MM-DD'),
      toDate: toDate.format('YYYY-MM-DD'),
    },
  }).then(response => response.data);
};

const getAllEmployees = (): Promise<Employee[]> => {
    return api.get('/dutyschedule/employees').then(response => response.data);
};

const saveDutySchedule = (saveRequest: SaveDutyScheduleRequest): Promise<void> => {
    return api.post('/dutyschedule', saveRequest);
};

const approveDutySchedule = (lichtrucId: number): Promise<void> => {
    return api.post(`/dutyschedule/${lichtrucId}/approve`);
};

const unapproveDutySchedule = (lichtrucId: number): Promise<void> => {
    return api.post(`/dutyschedule/${lichtrucId}/unapprove`);
};



// New interfaces for viewing a single day's schedule
export interface EmployeeDetail {
  maChamCong: string;
  tenNV: string;
  tenKK: string; // Department Name
  dienThoai: string;
  isKem: boolean;
}

export interface DutyPositionWithEmployees {
  vitriTrucId: number;
  tenViTri: string;
  moTa: string;
  thuTuHienThi: number;
  employees: EmployeeDetail[];
}

export interface ViewDutySchedule {
  date: string; // ISO string
  isApproved: boolean;
  approverName: string | null;
  approvalDate: string | null; // ISO string
  dutyPositions: DutyPositionWithEmployees[];
}

// New function to get a single day's schedule
const getViewDutySchedule = (date: Dayjs): Promise<ViewDutySchedule> => {
  return api.get('/dutyschedule/view', {
    params: {
      date: date.format('YYYY-MM-DD'),
    },
  }).then(response => response.data);
};

export const dutyScheduleService = {
  getDutySchedule,
  getAllEmployees,
  saveDutySchedule,
  approveDutySchedule,
  unapproveDutySchedule,
  getViewDutySchedule, // Add this
};
